"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.styles = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _ThemeHelper = require("../Utilities/ThemeHelper");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

var styles = (0, _ThemeHelper.createStyles)(function (theme) {
  var _theme$scrollbars, _theme$scrollbars2;

  return {
    dialog: _objectSpread({
      borderRadius: 1,
      maxHeight: "calc(100% - 96px)"
    }, (_theme$scrollbars = theme.scrollbars) === null || _theme$scrollbars === void 0 ? void 0 : _theme$scrollbars.main),
    dialogContent: _objectSpread(_objectSpread({
      paddingBottom: theme.spacing(3),
      // If this is changed, update calculateHeight() in Dialog.js
      position: "relative"
    }, (_theme$scrollbars2 = theme.scrollbars) === null || _theme$scrollbars2 === void 0 ? void 0 : _theme$scrollbars2.main), {}, {
      minHeight: 0
    }),
    dialogContentMaxHeightTransition: {
      transition: theme.transitions.create(["min-height"])
    },
    closeButton: {
      position: "absolute",
      right: theme.spacing(2),
      top: theme.spacing(2)
    },
    title: {
      padding: "26px 86px 16px 25px"
    },
    buttons: {
      margin: 0,
      padding: theme.spacing(2)
    }
  };
});
exports.styles = styles;